import React from "react";
import styles from "./HighlightBox.module.less";

export interface Props {
    heading: string;
    content: string;
}

export default function HighlightBox(props: Props) {
    return (
        <div className={styles.HighlightBox}>
            <h2 className={styles["HighlightBox-heading"]}><span>{props.heading}</span></h2>
            <div className={styles["HighlightBox-content"]} dangerouslySetInnerHTML={{ __html: props.content }} />
        </div>
    );
}
